import { Dashboard } from '../../models/Dashboard'
import { RecordFactory } from '../../models/RecordFactory'
import { User } from '../../models/User'
import { ComponentData } from '../../utils/typing'
import { PocketComponent, PocketComponentProps, usePSComponent } from '../PocketComponent'
import Button from '../app/design/Button'
import Paragraph from '../app/design/Paragraph'
import Tooltip from '../app/design/Tooltip'
import { ContactAvatar } from '../contacts/ContactAvatar'

type Props = {
    dashboard: Dashboard
}

const viewWillAppear = async (base: PocketComponent<Props>) => {
    const booking = await RecordFactory.getInstance().loadBooking(base.props.dashboard.metaData.id)
    return { booking }
}

const render = ({
    data,
    base,
}: PocketComponentProps<ComponentData<typeof viewWillAppear>, Props>) => {
    if (!data.booking) return null

    const { dashboard } = base.props

    return (
        <div className="flex flex-col gap-4">
            <div className="flex items-center justify-between">
                <ContactAvatar
                    user={data.booking.client ?? new User()}
                    showName={true}
                    subtitle={
                        <div className="flex flex-col gap-y-1">
                            <Paragraph size="sm" className="text-gray-600">
                                {data.booking.service?.name}
                            </Paragraph>
                            <Paragraph size="sm" className="text-gray-600">
                                {dashboard.status}
                            </Paragraph>
                        </div>
                    }
                />

                {data.booking.job?.person && (
                    <Tooltip label={data.booking.job?.person.name ?? ''} position="left">
                        <ContactAvatar size="xs" user={data.booking.job?.person} />
                    </Tooltip>
                )}
            </div>
            <Button
                intent="primary"
                size="small"
                className="w-full"
                href={data.booking.conferenceUrlString}
                target="_blank"
            >
                Join
            </Button>
        </div>
    )
}

export const JoinConferenceCard = usePSComponent(render, viewWillAppear)
